var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content queryBillPayment" },
    [
      _c(
        "search-item",
        {
          key: _vm.identify,
          ref: _vm.identify,
          attrs: {
            "show-more-scheme": true,
            "show-simple": true,
            "expand-adv": true,
            "search-item-code": _vm.searchItemCode,
            "config-module": _vm.configModule,
            "grid-config-module": _vm.gridConfigModule,
            "auto-init": _vm.searchItemAutoInit,
            "custom-search-items": _vm.customSearchItems,
            "custom-sim-query-placeholder": _vm.simQueryPlaceholder
          },
          on: {
            advSearchItemCallBack: _vm.fetchData,
            simSearchItemCallBack: _vm.fetchDataBykeyWord,
            advToggle: _vm.scrollCallback,
            perConfigChange: function(value) {
              _vm.perConfigName = value
            },
            refreshGrid: function() {
              _vm.gridRefreshId += 1
            }
          }
        },
        [
          _c("template", { slot: "operations" }, [_vm._t("operations")], 2),
          _c(
            "template",
            { slot: "searchAreaHeader" },
            [_vm._t("searchAreaHeader")],
            2
          )
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "section grid-wrapper",
          staticStyle: { "min-height": "300px" }
        },
        [
          _c("cargo-ag-grid-wrapper", {
            attrs: {
              "config-module": _vm.gridConfigModule,
              "per-config-name": _vm.perConfigName,
              "refresh-id": _vm.gridRefreshId,
              "grid-params": _vm.billPaymentGrid.gridParams,
              "grid-options": _vm.billPaymentGrid.gridOptions,
              "column-defs": _vm.dynamicColumnDefs,
              "row-data": _vm.billPaymentGrid.rowData,
              "show-row-groups": _vm.dataListDragGroup
            },
            on: {
              "update:gridParams": function($event) {
                return _vm.$set(_vm.billPaymentGrid, "gridParams", $event)
              },
              "update:grid-params": function($event) {
                return _vm.$set(_vm.billPaymentGrid, "gridParams", $event)
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "pagination-wrapper",
          attrs: { id: "footer-wrapper-tab-billpayment" }
        },
        [
          _c(
            "div",
            {
              class: [_vm.shouldFixed ? "fixedBottom" : ""],
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "flex-wrap": "wrap"
              }
            },
            [
              _vm.dataShow &&
              ["billPaymentList", "Writeoff"].includes(_vm.viewSource)
                ? _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.totalAmountToCurrencyBillPaymentGrid.labelText
                      )
                    }
                  })
                : _vm._e(),
              _vm.dataShow &&
              ["billPaymentList", "Writeoff"].includes(_vm.viewSource)
                ? _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.totalAmountToCurrencyBillPaymentGrid
                          .selectionCountLabel
                      )
                    }
                  })
                : _vm._e(),
              _vm.reCalc
                ? _c("charge-currency-total-group", {
                    key: 1,
                    attrs: {
                      type: _vm.totalType,
                      "amount-to-currency": _vm.localCurrency,
                      "data-field": _vm.totalDataField,
                      "data-provider":
                        _vm.totalAmountToCurrencyBillPaymentGrid.dataProvider,
                      "rate-field": _vm.rateField,
                      "ar-field": _vm.arField,
                      "show-wht": _vm.showWht
                    }
                  })
                : _vm._e(),
              _vm.showTotalUnverifiedAmount &&
              ["billPaymentList", "Writeoff"].includes(_vm.viewSource)
                ? _c("span", {
                    domProps: {
                      textContent: _vm._s(_vm.totalAmountNotWrittenOffLabel)
                    }
                  })
                : _vm._e(),
              _vm.reCalc &&
              _vm.showTotalUnverifiedAmount &&
              ["billPaymentList", "Writeoff"].includes(_vm.viewSource)
                ? _c("charge-currency-total-group", {
                    key: 2,
                    attrs: {
                      type: _vm.totalType,
                      "amount-to-currency": _vm.localCurrency,
                      "data-field": "unverifiedAmount",
                      "data-provider":
                        _vm.totalAmountToCurrencyBillPaymentGrid.dataProvider,
                      "rate-field": _vm.rateField,
                      "ar-field": _vm.arField,
                      "show-wht": _vm.showWht
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("cargo-pagination", {
            ref: "paginationBillPayment",
            attrs: {
              "config-module": _vm.gridConfigModule,
              total: _vm.searchConditions.total,
              page: _vm.searchConditions.pageNum,
              limit: _vm.searchConditions.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.searchConditions, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.searchConditions, "pageSize", $event)
              },
              pagination: _vm.fetchDataByPage
            }
          })
        ],
        1
      ),
      _vm.workFlowApplyDialog.visible
        ? _c("bill-payment-work-flow-apply-dialog", {
            attrs: {
              visible: _vm.workFlowApplyDialog.visible,
              "bill-payment": _vm.workFlowApplyDialog.billPayment,
              title: _vm.$t("CargoMsg.Cargo_Approving"),
              "process-info": _vm.workFlowApplyDialog.documentProcess,
              records: _vm.workFlowApplyDialog.approvalCommentsRecords,
              type: "approve"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.workFlowApplyDialog, "visible", $event)
              },
              close: function($event) {
                _vm.workFlowApplyDialog.visible = false
              },
              closeAndRefresh: function() {
                _vm.workFlowApplyDialog.visible = false
                _vm.fetchDataByPage()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }